import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpUtils } from '../utils/httpUtils';

@Injectable({
  providedIn: 'root'
})
export class PendingSignExecutionService {

  readonly baseUrl = environment.airUrl + '/pendingSignExecution';
  constructor(private http: HttpClient) {
  }

  validateByIdAndUsername(idExecution: number): Observable<any> {
    const url = `${this.baseUrl}/validate/${idExecution}`;

    return this.http.get(url).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }

}
